export type OutcomeColor = 'default' | 'success' | 'warning' | 'error';

export const getOutcomeColor = (outcome?: string): OutcomeColor => {
  switch (outcome) {
    case 'denied':
      return 'error';
    case 'failed':
      return 'warning';
    case 'ok':
      return 'success';
    default:
      return 'default';
  }
};
